import { createTheme } from '@material-ui/core';

export default createTheme({
  palette: {
    primary: {
      disabled: '#ffdbe4',
      idle: '#ff8aa6',
      hover: '#ff7092',
      pressed: '#ff5c82',
      darker: '#864860',
      main: '#e35d7d',
    },
    secondary: {
      disabled: '#c2eae7',
      idle: '#2E9E95',
      hover: '#32aea4',
      pressed: '#2e9e95',
      main: '#2E9E95',
    },
    common: {
      yellow: '#ffa700',
      topaz: '#12adc4',
      green: '#6fc412',
      magenta: '#ff00de',
      modal: 'rgba(134, 72, 96, 0.8)',
      scrollbar: '#ffa700',
    },
  },
});
